import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';

const checkBoxes = (props) => {
  let value = props.value;
  let filterObject = props.filterObject;
  //console.log(JSON.stringify(props.value) + 'input values');
  let classname = props.classname ? "form-control col"+props.classname : "form-control col";
  return (
      <Wrp>
        <select className={classname} name="action1" onChange={e=>props.filterOnChange(e, props.attr1, 'inputField', filterObject.has_multiple_input,props.attr4)} value={props.value[0]} >
           <option value="">&nbsp;</option>
           <option value={true}>True</option>
           <option value={false}>False</option>
        </select>
      </Wrp>
    );
}

export default checkBoxes;